(function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const root = document.getElementById('cart-drawer-root');

  const ICONS = {
    close: '<svg class="cart-drawer__icon cart-drawer__icon--lg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    bag: '<svg class="cart-drawer__icon cart-drawer__icon--sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
    trash: '<svg class="cart-drawer__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
    chevron: '<svg class="cart-drawer__icon cart-drawer__upsell-chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',
    note: '<svg class="cart-drawer__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
    tag: '<svg class="cart-drawer__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
    truck: '<svg class="cart-drawer__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
  };

  const config = {
    threshold: parseInt(drawer.dataset.threshold || '0', 10),
    currency: drawer.dataset.currency || 'AED',
    upsellCollection: drawer.dataset.upsellCollection || '',
    checkoutUrl: drawer.dataset.checkoutUrl || '/checkout',
    cartUrl: drawer.dataset.cartUrl || '/cart',
    strings: {
      title: drawer.dataset.title || 'Your cart',
      spendMore: drawer.dataset.spendMore || 'Spend {{ amount }} more for FREE shipping!',
      freeShipping: drawer.dataset.freeShipping || "You've unlocked FREE shipping!",
      mightLike: drawer.dataset.mightLike || 'You might also like',
      giftWrapping: drawer.dataset.giftWrapping || 'Gift wrapping',
      orderNote: drawer.dataset.orderNote || 'Order Note',
      discountCode: drawer.dataset.discountCode || 'Discount Code',
      shipping: drawer.dataset.shipping || 'Shipping',
      subtotal: drawer.dataset.subtotal || 'Subtotal',
      taxNote: drawer.dataset.taxNote || 'Shipping & taxes calculated at checkout',
      checkout: drawer.dataset.checkout || 'Check out',
      empty: drawer.dataset.empty || 'Your cart is empty',
      continueShopping: drawer.dataset.continueShopping || 'Continue shopping',
      color: drawer.dataset.color || 'Color',
      size: drawer.dataset.size || 'Size',
      apply: drawer.dataset.apply || 'Apply',
      saveNote: drawer.dataset.saveNote || 'Save',
      shippingText: drawer.dataset.shippingText || '',
      discountHint: drawer.dataset.discountHint || 'Enter your discount code below.',
      addOrderNote: 'ADD ORDER NOTE',
      discountTitle: 'DISCOUNT CODE',
      discount: 'Discount',
      total: 'Total',
      discountApplied: 'Discount applied',
      discountInvalid: 'This discount code is invalid or cannot be applied',
      shippingTitle: 'SHIPPING',
      howHelp: 'How can we help you?',
      enterDiscount: 'Enter discount code',
    },
  };

  let cart = null;
  let activePanel = null;
  let upsellOpen = true;
  let upsellProducts = [];
  let discountFeedback = null;

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getApplicableDiscountCodes(cartData) {
    return (cartData.discount_codes || [])
      .filter(function (d) {
        return d && d.applicable && d.code;
      })
      .map(function (d) {
        return d.code;
      });
  }

  function renderDiscountSummary(cartData) {
    var totalDiscount = cartData.total_discount || 0;
    var codes = getApplicableDiscountCodes(cartData);
    if (!totalDiscount && !codes.length) return '';

    var rows = '';
    if (codes.length) {
      rows +=
        '<div class="cart-drawer__discount-codes">' +
        codes
          .map(function (code) {
            return '<span class="cart-drawer__discount-code">' + escapeHtml(code) + '</span>';
          })
          .join('') +
        '</div>';
    }
    if (totalDiscount > 0) {
      rows +=
        '<div class="cart-drawer__subtotal-row cart-drawer__subtotal-row--discount">' +
        '<span class="cart-drawer__subtotal-label">' +
        config.strings.discount +
        '</span>' +
        '<span class="cart-drawer__subtotal-value">−' +
        formatMoney(totalDiscount) +
        '</span></div>';
    }
    return rows;
  }

  function formatMoney(cents) {
    if (window.AlboushiyaCurrency && typeof window.AlboushiyaCurrency.formatFromAedCents === 'function') {
      return window.AlboushiyaCurrency.formatFromAedCents(cents);
    }
    var amount = (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return (config.currency || 'AED') + ' ' + amount;
  }

  function updateCartCount(count) {
    document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.classList.contains('header__cart-count')) {
        el.style.display = count > 0 ? 'flex' : 'none';
      } else {
        el.classList.toggle('hidden', count < 1);
      }
    });
    if (window.fixCurrency) window.fixCurrency();
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    cart = await res.json();
    return cart;
  }

  async function changeLine(key, quantity) {
    if (cart) {
      cart.items = cart.items
        .map(function (i) {
          if (i.key !== key) return i;
          const newQty = Math.max(0, quantity);
          return Object.assign({}, i, {
            quantity: newQty,
            final_line_price: i.price * newQty,
          });
        })
        .filter(function (i) {
          return i.quantity > 0;
        });
      cart.item_count = cart.items.reduce(function (s, i) {
        return s + i.quantity;
      }, 0);
      cart.total_price = cart.items.reduce(function (s, i) {
        return s + i.final_line_price;
      }, 0);
      updateCartCount(cart.item_count);
      render();
    }
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    cart = await res.json();
    return cart;
  }

  async function updateCart(payload) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    cart = await res.json();
    return cart;
  }

  async function addToCart(items) {
    if (cart) {
      const addedQty = items.reduce(function (s, i) {
        return s + (i.quantity || 1);
      }, 0);
      cart.item_count = (cart.item_count || 0) + addedQty;
      updateCartCount(cart.item_count);
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    });
    if (!res.ok) {
      if (cart) updateCartCount(cart.item_count);
      throw new Error('Add to cart failed');
    }
    await fetchCart();
    return cart;
  }

  function getVariantLabel(item) {
    if (item.options_with_values && item.options_with_values.length) {
      return item.options_with_values
        .map(function (opt) {
          const name = opt.name.toLowerCase();
          const label =
            name === 'color' ? config.strings.color : name === 'size' ? config.strings.size : opt.name;
          return label + ': ' + opt.value;
        })
        .join('<br>');
    }
    const parts = [];
    if (item.option1 && item.option1 !== 'Default Title') parts.push(config.strings.color + ': ' + item.option1);
    if (item.option2) parts.push(config.strings.size + ': ' + item.option2);
    if (item.option3) parts.push(item.option3);
    return parts.join('<br>');
  }

  function shippingProgress(total) {
    if (!config.threshold) return { percent: 100, message: config.strings.freeShipping };
    const remaining = Math.max(0, config.threshold - total);
    const percent = Math.min(100, (total / config.threshold) * 100);
    const message =
      remaining > 0
        ? config.strings.spendMore.replace('{{ amount }}', formatMoney(remaining))
        : config.strings.freeShipping;
    return { percent: percent, message: message };
  }

  async function loadUpsell(cartData) {
    upsellProducts = [];

    if (cartData.items.length > 0) {
      const productId = cartData.items[0].product_id;
      try {
        const res = await fetch(
          '/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related'
        );
        const data = await res.json();
        upsellProducts = (data.products || []).slice(0, 4);
      } catch (e) {
        upsellProducts = [];
      }
    }

    if (upsellProducts.length === 0 && config.upsellCollection) {
      try {
        const res = await fetch('/collections/' + config.upsellCollection + '/products.json?limit=6');
        const data = await res.json();
        upsellProducts = (data.products || []).slice(0, 4);
      } catch (e) {
        upsellProducts = [];
      }
    }
  }

  async function addUpsellVariant(variantId) {
    const existing = cart && cart.items && cart.items.find(function (i) {
      return i.variant_id === variantId;
    });
    if (existing) {
      await changeLine(existing.key, existing.quantity + 1);
      return;
    }
    await addToCart([{ id: variantId, quantity: 1 }]);
    render();
  }

  function renderUpsell() {
    if (!upsellProducts.length) return '';

    const cards = upsellProducts
      .map(function (product) {
        const variant = product.variants.find(function (v) {
          return v.available;
        }) || product.variants[0];
        if (!variant) return '';
        const img = product.featured_image || (product.images && product.images[0]);
        const imgSrc = img ? (typeof img === 'string' ? img : img.src) : '';
        return (
          '<div class="cart-drawer__upsell-card">' +
          '<img class="cart-drawer__upsell-img" src="' +
          imgSrc +
          '" alt="' +
          (product.title || '') +
          '" loading="lazy">' +
          '<div class="cart-drawer__upsell-card-body">' +
          '<p class="cart-drawer__upsell-vendor">' +
          (product.vendor || '') +
          '</p>' +
          '<p class="cart-drawer__upsell-name">' +
          product.title +
          '</p>' +
          '<p class="cart-drawer__upsell-price">' +
          formatMoney(variant.price) +
          '</p>' +
          '<button type="button" class="cart-drawer__upsell-add" data-upsell-add="' +
          variant.id +
          '" aria-label="Add to cart">' +
          ICONS.bag +
          '</button>' +
          '</div></div>'
        );
      })
      .join('');

    return (
      '<div class="cart-drawer__upsell' +
      (upsellOpen ? ' is-open' : '') +
      '">' +
      '<button type="button" class="cart-drawer__upsell-toggle" data-upsell-toggle>' +
      '<span>' +
      config.strings.mightLike +
      '</span>' +
      ICONS.chevron +
      '</button>' +
      '<div class="cart-drawer__upsell-panel">' +
      '<div class="cart-drawer__upsell-track">' +
      cards +
      '</div></div></div>'
    );
  }

  function renderItems(items) {
    if (!items.length) {
      return (
        '<div class="cart-drawer__empty">' +
        '<p>' +
        config.strings.empty +
        '</p>' +
        '<a href="/" data-cart-drawer-close>' +
        config.strings.continueShopping +
        '</a></div>'
      );
    }

    return items
      .map(function (item) {
        const label = getVariantLabel(item);
        return (
          '<div class="cart-drawer__item" data-line-key="' +
          item.key +
          '">' +
          '<img class="cart-drawer__item-image" src="' +
          (item.image || '') +
          '" alt="' +
          (item.title || '') +
          '" loading="lazy" width="88" height="110">' +
          '<div>' +
          '<p class="cart-drawer__item-title">' +
          item.product_title +
          '</p>' +
          (label ? '<p class="cart-drawer__item-variant">' + label + '</p>' : '') +
          '<div class="cart-drawer__qty-row">' +
          '<div class="cart-drawer__qty">' +
          '<button type="button" data-qty-change="' +
          item.key +
          '" data-qty="' +
          (item.quantity - 1) +
          '" aria-label="Decrease quantity">−</button>' +
          '<span>' +
          item.quantity +
          '</span>' +
          '<button type="button" data-qty-change="' +
          item.key +
          '" data-qty="' +
          (item.quantity + 1) +
          '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="cart-drawer__remove" data-qty-change="' +
          item.key +
          '" data-qty="0" aria-label="Remove item">' +
          ICONS.trash +
          '</button></div></div>' +
          '<p class="cart-drawer__item-price">' +
          formatMoney(item.final_line_price) +
          '</p></div>'
        );
      })
      .join('');
  }

  function renderSheetContent() {
    if (!activePanel) return '';

    if (activePanel === 'note') {
      return (
        '<div class="cart-drawer__sheet-header">' +
        '<h3 class="cart-drawer__sheet-title">' +
        config.strings.addOrderNote +
        '</h3>' +
        '<button type="button" class="cart-drawer__sheet-close" data-sheet-close aria-label="Close">' +
        ICONS.close +
        '</button></div>' +
        '<textarea data-cart-note placeholder="' +
        config.strings.howHelp +
        '">' +
        (cart.note || '') +
        '</textarea>' +
        '<button type="button" class="cart-drawer__sheet-btn" data-save-note>' +
        config.strings.saveNote +
        '</button>'
      );
    }

    if (activePanel === 'discount') {
      var appliedCodes = getApplicableDiscountCodes(cart);
      var appliedHtml = '';
      if (appliedCodes.length) {
        appliedHtml =
          '<div class="cart-drawer__discount-applied">' +
          appliedCodes
            .map(function (code) {
              return (
                '<div class="cart-drawer__discount-chip">' +
                '<span>' +
                escapeHtml(code) +
                '</span>' +
                '<button type="button" data-remove-discount="' +
                escapeHtml(code) +
                '" aria-label="Remove discount">×</button></div>'
              );
            })
            .join('') +
          '</div>';
      }
      var feedbackHtml = '';
      if (discountFeedback) {
        feedbackHtml =
          '<p class="cart-drawer__discount-feedback cart-drawer__discount-feedback--' +
          discountFeedback.type +
          '">' +
          escapeHtml(discountFeedback.message) +
          '</p>';
      }
      return (
        '<div class="cart-drawer__sheet-header">' +
        '<h3 class="cart-drawer__sheet-title">' +
        config.strings.discountTitle +
        '</h3>' +
        '<button type="button" class="cart-drawer__sheet-close" data-sheet-close aria-label="Close">' +
        ICONS.close +
        '</button></div>' +
        '<p class="cart-drawer__sheet-info">' +
        config.strings.discountHint +
        '</p>' +
        appliedHtml +
        '<input type="text" data-discount-input placeholder="' +
        config.strings.enterDiscount +
        '" autocomplete="off">' +
        '<button type="button" class="cart-drawer__sheet-btn" data-apply-discount>' +
        config.strings.apply +
        '</button>' +
        feedbackHtml
      );
    }

    if (activePanel === 'shipping') {
      return (
        '<div class="cart-drawer__sheet-header">' +
        '<h3 class="cart-drawer__sheet-title">' +
        config.strings.shippingTitle +
        '</h3>' +
        '<button type="button" class="cart-drawer__sheet-close" data-sheet-close aria-label="Close">' +
        ICONS.close +
        '</button></div>' +
        '<p class="cart-drawer__sheet-info">' +
        (config.strings.shippingText || config.strings.taxNote) +
        '</p>'
      );
    }

    return '';
  }

  function openSheet() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        const wrap = root && root.querySelector('.cart-drawer__sheet-wrap');
        if (wrap) wrap.classList.add('is-open');
      });
    });
  }

  function closeSheet(callback) {
    const wrap = root && root.querySelector('.cart-drawer__sheet-wrap');
    if (!wrap || !wrap.classList.contains('is-open')) {
      if (callback) callback();
      return;
    }
    wrap.classList.remove('is-open');
    let fired = false;
    const done = function () {
      if (fired) return;
      fired = true;
      wrap.removeEventListener('transitionend', done);
      if (callback) callback();
    };
    wrap.addEventListener('transitionend', done);
    setTimeout(done, 400);
  }

  function render() {
    if (!cart || !root) return;

    const progress = shippingProgress(cart.total_price);
    const giftChecked =
      cart.attributes &&
      (cart.attributes['Gift wrapping'] === 'Yes' || cart.attributes['gift_wrapping'] === 'Yes');
    const sheetContent = renderSheetContent();

    root.innerHTML =
      '<div class="cart-drawer__header">' +
      '<h2 class="cart-drawer__title" id="cart-drawer-title">' +
      config.strings.title +
      ' (' +
      cart.item_count +
      ')</h2>' +
      '<button type="button" class="cart-drawer__close" data-cart-drawer-close aria-label="Close cart">' +
      ICONS.close +
      '</button></div>' +
      (cart.item_count > 0 && config.threshold
        ? '<div class="cart-drawer__shipping"><p class="cart-drawer__shipping-text">' +
          progress.message +
          '</p><div class="cart-drawer__progress"><div class="cart-drawer__progress-bar" style="width:' +
          progress.percent +
          '%"></div></div></div>'
        : '') +
      '<div class="cart-drawer__body">' +
      '<div class="cart-drawer__items">' +
      renderItems(cart.items) +
      '</div>' +
      (cart.item_count > 0 ? renderUpsell() : '') +
      (cart.item_count > 0
        ? '<div class="cart-drawer__extras">' +
          '<label class="cart-drawer__gift">' +
          '<input type="checkbox" data-gift-wrap ' +
          (giftChecked ? 'checked' : '') +
          '>' +
          '<span>' +
          config.strings.giftWrapping +
          '</span></label>' +
          '<div class="cart-drawer__actions">' +
          '<button type="button" class="cart-drawer__action' +
          (activePanel === 'note' ? ' is-active' : '') +
          '" data-panel="note">' +
          ICONS.note +
          '<span>' +
          config.strings.orderNote +
          '</span></button>' +
          '<button type="button" class="cart-drawer__action' +
          (activePanel === 'discount' ? ' is-active' : '') +
          '" data-panel="discount">' +
          ICONS.tag +
          '<span>' +
          config.strings.discountCode +
          '</span></button>' +
          '<button type="button" class="cart-drawer__action' +
          (activePanel === 'shipping' ? ' is-active' : '') +
          '" data-panel="shipping">' +
          ICONS.truck +
          '<span>' +
          config.strings.shipping +
          '</span></button></div></div>'
        : '') +
      '</div>' +
      (cart.item_count > 0
        ? '<div class="cart-drawer__footer">' +
          (cart.total_discount > 0
            ? '<div class="cart-drawer__subtotal-row">' +
              '<span class="cart-drawer__subtotal-label">' +
              config.strings.subtotal +
              '</span>' +
              '<span class="cart-drawer__subtotal-value">' +
              formatMoney(cart.items_subtotal_price || cart.original_total_price || cart.total_price) +
              '</span></div>' +
              renderDiscountSummary(cart) +
              '<div class="cart-drawer__subtotal-row cart-drawer__subtotal-row--total">' +
              '<span class="cart-drawer__subtotal-label">' +
              config.strings.total +
              '</span>' +
              '<span class="cart-drawer__subtotal-value">' +
              formatMoney(cart.total_price) +
              '</span></div>'
            : '<div class="cart-drawer__subtotal-row">' +
              '<span class="cart-drawer__subtotal-label">' +
              config.strings.subtotal +
              '</span>' +
              '<span class="cart-drawer__subtotal-value">' +
              formatMoney(cart.total_price) +
              '</span></div>' +
              renderDiscountSummary(cart)) +
          '<p class="cart-drawer__tax-note">' +
          config.strings.taxNote +
          '</p>' +
          '<a href="' +
          config.checkoutUrl +
          '" class="cart-drawer__checkout">' +
          config.strings.checkout +
          '</a></div>'
        : '') +
      '<div class="cart-drawer__sheet-wrap">' +
      '<div class="cart-drawer__sheet-bg" data-sheet-close></div>' +
      '<div class="cart-drawer__sheet">' +
      sheetContent +
      '</div></div>';

    bindEvents();
    updateCartCount(cart.item_count);
    if (activePanel) openSheet();
  }

  function bindEvents() {
    root.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    root.querySelectorAll('[data-sheet-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeSheet(function () {
          activePanel = null;
          render();
        });
      });
    });

    root.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const key = btn.dataset.qtyChange;
        const qty = parseInt(btn.dataset.qty, 10);
        await changeLine(key, qty);
        await loadUpsell(cart);
        render();
      });
    });

    const gift = root.querySelector('[data-gift-wrap]');
    if (gift) {
      gift.addEventListener('change', async function () {
        await updateCart({ attributes: { 'Gift wrapping': gift.checked ? 'Yes' : 'No' } });
      });
    }

    root.querySelectorAll('[data-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const panelName = btn.dataset.panel;
        if (activePanel === panelName) {
          closeSheet(function () {
            activePanel = null;
            render();
          });
        } else {
          activePanel = panelName;
          render();
        }
      });
    });

    const saveNote = root.querySelector('[data-save-note]');
    if (saveNote) {
      saveNote.addEventListener('click', async function () {
        const noteEl = root.querySelector('[data-cart-note]');
        const note = (noteEl && noteEl.value) || '';
        await updateCart({ note: note });
        closeSheet(function () {
          activePanel = null;
          render();
        });
      });
    }

    const applyDiscount = root.querySelector('[data-apply-discount]');
    if (applyDiscount) {
      applyDiscount.addEventListener('click', async function () {
        const input = root.querySelector('[data-discount-input]');
        const code = input && input.value ? input.value.trim() : '';
        if (!code) {
          discountFeedback = { type: 'error', message: config.strings.enterDiscount };
          render();
          return;
        }

        applyDiscount.disabled = true;
        applyDiscount.textContent = '…';
        discountFeedback = null;

        try {
          const existing = getApplicableDiscountCodes(cart);
          const nextCodes = existing.slice();
          if (
            !nextCodes.some(function (c) {
              return c.toLowerCase() === code.toLowerCase();
            })
          ) {
            nextCodes.push(code);
          }

          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: nextCodes.join(',') }),
          });
          const data = await res.json();
          if (!res.ok) {
            throw new Error((data && data.description) || config.strings.discountInvalid);
          }

          cart = data;
          const applied = getApplicableDiscountCodes(cart).some(function (c) {
            return c.toLowerCase() === code.toLowerCase();
          });

          if (!applied) {
            discountFeedback = { type: 'error', message: config.strings.discountInvalid };
            render();
            return;
          }

          discountFeedback = { type: 'success', message: config.strings.discountApplied };
          closeSheet(function () {
            activePanel = null;
            discountFeedback = null;
            render();
          });
        } catch (err) {
          discountFeedback = {
            type: 'error',
            message: (err && err.message) || config.strings.discountInvalid,
          };
          render();
        }
      });
    }

    root.querySelectorAll('[data-remove-discount]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const removeCode = btn.getAttribute('data-remove-discount');
        const remaining = getApplicableDiscountCodes(cart).filter(function (c) {
          return c.toLowerCase() !== String(removeCode || '').toLowerCase();
        });
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: remaining.join(',') }),
          });
          cart = await res.json();
          discountFeedback = null;
          render();
        } catch (e) {
          discountFeedback = { type: 'error', message: config.strings.discountInvalid };
          render();
        }
      });
    });

    const upsellToggle = root.querySelector('[data-upsell-toggle]');
    if (upsellToggle) {
      upsellToggle.addEventListener('click', function () {
        upsellOpen = !upsellOpen;
        const el = root.querySelector('.cart-drawer__upsell');
        if (el) el.classList.toggle('is-open', upsellOpen);
      });
    }

    root.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        const variantId = parseInt(btn.dataset.upsellAdd, 10);
        btn.disabled = true;
        try {
          await addUpsellVariant(variantId);
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');

    if (cart) render();

    fetchCart().then(async function (data) {
      await loadUpsell(data);
      render();
    });
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    activePanel = null;
  }

  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  const overlay = drawer.querySelector('.cart-drawer__overlay');
  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activePanel) {
        closeSheet(function () {
          activePanel = null;
          render();
        });
      } else if (drawer.classList.contains('is-open')) {
        close();
      }
    }
  });

  fetchCart().then(async function (data) {
    updateCartCount(data.item_count);
    await loadUpsell(data);
  });

  window.CartDrawer = {
    open: open,
    close: close,
    refresh: fetchCart,
    addToCart: addToCart,
    loadUpsell: loadUpsell,
  };
})();
